import React, { createContext, useReducer, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axios from "axios";

const API_URL = "https://api.nwayami.com/api";

const AuthContext = createContext();

const initialState = {
  user: null,
  error: null,
};

const authReducer = (state, action) => {
  switch (action.type) {
    case "SET_USER":
      return { ...state, user: action.payload, error: null };
    case "SET_ERROR":
      return { ...state, error: action.payload };
    case "CLEAR_USER":
      return { ...state, user: null, error: null };
    default:
      return state;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  // 🔹 Login com busca de dados do usuário
  const loginUser = async (email, password, redirectPath = "/") => {
    try {
      const response = await axios.post(`${API_URL}/token/`, { email, password });
      const { access, refresh } = response.data;

      localStorage.setItem("authToken", access);
      localStorage.setItem("refreshToken", refresh);

      const decoded = jwtDecode(access);
      const userId = decoded.user_id || decoded.id;

      // 🔸 Busca os dados completos do usuário
      const userResponse = await axios.get(`${API_URL}/user/`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });

      const userData = {
        ...userResponse.data,
        token: access,
      };

      dispatch({
        type: "SET_USER",
        payload: userData,
      });

      navigate(redirectPath, { replace: true });
      return true;
    } catch (error) {
      dispatch({
        type: "SET_ERROR",
        payload: error?.response?.data?.detail || "Erro ao fazer login",
      });
      return false;
    }
  };

  // 🔹 Registro do usuário (sem endereço)
  const registerUser = async (email, username, telefone, password, confirmPassword, isBuyer) => {
    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}/register/`, {
        email,
        username,
        telefone,
        password,
        confirm_password: confirmPassword,
        is_buyer: isBuyer,
      });

      const userData = response.data;
      dispatch({ type: "SET_USER", payload: userData });
      setLoading(false);
      return userData;
    } catch (error) {
      console.error("Erro ao registrar usuário:", error.response?.data || error.message);
      setErrorMessage(error?.response?.data?.message || "Erro ao registrar o usuário.");
      setLoading(false);
      throw error;
    }
  };

  // 🔹 Adição de endereço
  const addAddress = async (endereco) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("authToken");

      const response = await axios.post(`${API_URL}/enderecos/`, endereco, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setLoading(false);
      return response.data;
    } catch (error) {
      setLoading(false);
      setErrorMessage(error?.response?.data?.message || "Erro ao adicionar endereço.");
      throw error;
    }
  };

  // 🔹 Logout
  const logoutUser = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    dispatch({ type: "CLEAR_USER" });
    navigate("/loginpage");
  };

  return (
    <AuthContext.Provider
      value={{
        user: state.user,
        error: state.error || errorMessage,
        loading,
        loginUser,
        logoutUser,
        registerUser,
        addAddress,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
